import React, { forwardRef } from 'react';
import { type IconProps } from '@phosphor-icons/react';
import { SecurityCameraIcon } from '@phosphor-icons/react';

export function createMirroredIcon(Icon: React.ComponentType<IconProps>) {
    return forwardRef<SVGSVGElement, IconProps>((props, ref) => (
        <Icon {...props} ref={ref} mirrored />
    ));
}

export const SecurityCameraIconMirrored =
    createMirroredIcon(SecurityCameraIcon);

export { MagnifyingGlassAiIcon } from './MagnifyingGlassAiIcon';
